import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyClipboardDirective } from './copy-clipboard.directive';
import {DragDropDirective} from './drag-drop.directive';
import { MatBadgeIconDirective } from './badge-icon.directive';

@NgModule({
  imports: [CommonModule],
  exports: [
    CopyClipboardDirective,
    DragDropDirective,
    MatBadgeIconDirective
  ],
  declarations: [
    CopyClipboardDirective,
    DragDropDirective,
    MatBadgeIconDirective
  ],
  providers: [],
})
export class DirectivesModule { }